import { render, staticRenderFns } from "./projectScoringComByEx.vue?vue&type=template&id=a82644cc&"
import script from "./projectScoringComByEx.vue?vue&type=script&lang=js&"
export * from "./projectScoringComByEx.vue?vue&type=script&lang=js&"
import style0 from "./projectScoringComByEx.vue?vue&type=style&index=0&id=a82644cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports